import { render, staticRenderFns } from "./FileImage.vue?vue&type=template&id=dfbd6b80&scoped=true"
import script from "./FileImage.vue?vue&type=script&lang=js"
export * from "./FileImage.vue?vue&type=script&lang=js"
import style0 from "./FileImage.vue?vue&type=style&index=0&id=dfbd6b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbd6b80",
  null
  
)

export default component.exports